import { cloneDeep } from "lodash";
import { Component } from "react";
import { Dialog } from "../../components/dialogs/Dialog";
import { LoadingBar } from "../../components/LoadingBar";
import { TextField } from "../../components/TextField";
import { withLocale, WithLocaleProps } from "../../providers/LocaleProvider";

interface AddEditLocationDialogProps extends WithLocaleProps {
  theme?: any;
  location?: { locationId: any; name: string };
  saving?: boolean;
  error?: string | null;
  onClose?: () => void;
  onSave?: (locationId: any, locationName: string) => void;
}

class AddEditLocationDialogBase extends Component<AddEditLocationDialogProps, any> {
  originalLocation: { locationId: any; name: string } | null = null;

  constructor(props: any) {
    super(props);

    const locationId = props.location ? props.location.locationId : null;
    const locationName = props.location ? props.location.name : "";

    this.state = {
      locationId: locationId,
      locationName: locationName,
      valid: this.isValid(locationName),
      hasEdit: false
    };

    if (props.location) {
      this.originalLocation = cloneDeep({
        locationId: locationId,
        name: locationName
      });
    }
  }

  onChange(e: any) {
    const newLocationName = e.target.value;

    const hasEdit = this.checkForEdits(newLocationName);

    this.setState({
      locationName: newLocationName,
      valid: this.isValid(newLocationName),
      hasEdit: hasEdit
    });
  }

  isValid(locationName: any) {
    return locationName != null && locationName.length > 2;
  }

  checkForEdits(newName: string) {
    if (!this.originalLocation) {
      return newName.length > 0;
    }

    return newName !== this.originalLocation.name;
  }

  onSave() {
    const { locationId, locationName } = this.state;
    if (this.props.onSave) this.props.onSave(locationId, locationName);
  }

  render() {
    const { theme, onClose, saving, error, translate } = this.props;
    const { locationId, locationName, valid, hasEdit } = this.state;

    const saveEnabled = valid && (locationId === null || hasEdit);

    return (
      <Dialog
        open={true}
        theme={theme}
        title={locationId ? translate("settings.editLocation") : translate("settings.newLocation")}
        onClose={onClose}
        fullWidth={true}
        maxWidth='sm'
        actions={[
          {
            label: locationId ? translate("common.save") : translate("settings.addLocation"),
            primary: true,
            disabled: !saveEnabled || saving,
            onClick: this.onSave.bind(this)
          },
          {
            label: translate("common.cancel"),
            onClick: onClose
          }
        ]}
      >
        {saving && <LoadingBar loading={true} />}
        <TextField
          label={translate("entities.location")}
          placeholder={translate("entities.location")}
          autoComplete={false}
          autoFocus={true}
          sx={{ width: "100%" }}
          error={error !== null}
          helperText={error}
          value={locationName}
          onChange={this.onChange.bind(this)}
        />
      </Dialog>
    );
  }
}

export const AddEditLocationDialog = withLocale(AddEditLocationDialogBase);
